import {connect} from "react-redux"
import breakpointToViewportSize from "../../utils/breakpointToViewportSize"
import {fetchNextPageItemsThunk, selectHasNextPage} from "../../ducks/search"
import State from "../../models/State"

export const mapStateToProps = (state: State) => {
    const {
        search: {
            isFetchingNextPage,
            productLoadTrigger,
            totalResults,
            itemsPerPage: {initial, subsequent},
            endPage,
            currentBreakpoint,
            subsidiseItemsForLoadMore,
        },
    } = state

    let itemsLoaded =
        (endPage - 1) * subsequent[breakpointToViewportSize(currentBreakpoint)] +
        (subsidiseItemsForLoadMore ? initial[breakpointToViewportSize(currentBreakpoint)] : 0)

    if (totalResults < itemsLoaded) {
        itemsLoaded = totalResults
    }

    return {
        isFetchingNextPage,
        hasNextPage: selectHasNextPage(state),
        productLoadTrigger,
        totalResults,
        itemsLoaded,
        subsidiseItemsForLoadMore,
    }
}

export const mapDispatchToProps = {
    fetchNextPage: fetchNextPageItemsThunk,
}

export default connect(mapStateToProps, mapDispatchToProps)
